/* eslint-disable no-useless-constructor */
export class Operator {
  static N = 99;
  static EQUAL = new Operator("eq");
  static NOT_EQUAL = new Operator("neq");
  static LIKE = new Operator("like");
  static IN = new Operator("in", Operator.N);
  static BETWEEN = new Operator("between", 2);
  static GREATER_THAN = new Operator("gt");
  static GREATER_THAN_OR_EQUAL = new Operator("gte");
  static LESS_THAN = new Operator("lt");
  static LESS_THAN_OR_EQUAL = new Operator("lte");
  static START_WITH = new Operator("startWith");
  static END_WITH = new Operator("endWith");
  static IS_NULL = new Operator("is_null");
  static IS_NOT_NULL = new Operator("is_not_null");



  operator?: string;
  private count: number = 1;

  constructor(op?: string, count?: number) {
    if (op) {
      this.operator = op || Operator.LIKE.operator;
    }
    if (count) {
      this.count = count;
    }
  }

  getCount() {
    return this.count;
  }
}

export class LogicOperator extends Operator {
  public static AND = new LogicOperator("and", Operator.N);
  public static OR = new LogicOperator("or", Operator.N);
  public static NOT = new LogicOperator("not", 1);

  constructor(operator?: string, count?: number) {
    super(operator, count);
  }
}
